import React from 'react';
import SubscriptionsAdminPage from './SubscriptionsAdminPage';

export default function SubscriptionCenter() {
  return <div className="space-y-5" dir="rtl">
    <header className="border-b border-[var(--c-border)] pb-4">
      <p className="text-xs font-bold tracking-[0.18em] text-[var(--c-gold)]">SUBSCRIPTIONS</p>
      <h1 className="section-title mt-2 text-3xl">الاشتراكات</h1>
      <p className="mt-2 text-sm text-[var(--c-muted)]">الخطط والأسعار والفترات والتجديدات والمنح واشتراكات المستخدمين.</p>
    </header>
    <SubscriptionsAdminPage />
  </div>;
}
